import styled from "styled-components";

export const FormLoginStyled = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2.2rem;
`;

export const ErrorParagraph = styled.p`
  font-size: 1.2rem;
  color: var(--negative);
`;
